import { Grid, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import { BotonDePago } from "./BotonDePago";
import appYpf from "../../../images/ypf-icon.png";
import modo from "../../../images/modo-logo.png";
import mercadoPago from "../../../images/qr.png";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";

export const MetodosPagosKiosk = ({
  metodoPagoSeleccionado,
  setMetodoPagoSeleccionado,
}) => {
  const theme = useTheme();
  const handleSeleccionarMetodo = id => {
    // Si el método ya está seleccionado, lo deseleccionamos
    if (metodoPagoSeleccionado === id) {
      setMetodoPagoSeleccionado(null);
      console.log("Método de pago deseleccionado");
    } else {
      // Si no está seleccionado, lo seleccionamos
      setMetodoPagoSeleccionado(id);
      console.log("Método de pago seleccionado:", id);
    }
  };

  const mediosDePago = [
    {
      id: 1,
      icono: theme.bandera.logoPago,
      sizeIcon: theme.bandera.anchoLogo,
      onclick: () => handleSeleccionarMetodo(1),
    },
    {
      id: 2,
      icono: mercadoPago,
      sizeIcon: 80,
      onclick: () => handleSeleccionarMetodo(2),
    },
    {
      id: 3,
      icono: modo,
      sizeIcon: 150,
      onclick: () => handleSeleccionarMetodo(3),
    },
    {
      id: 4,
      nombre: "Tarjeta de Crédito",
      icono: <CreditCardIcon sx={{ fontSize: 50 }} />,
      sizeIcon: 40,
      onclick: () => handleSeleccionarMetodo(4),
    },
    {
      id: 5,
      nombre: "Tarjeta de Débito",
      icono: <CreditCardIcon sx={{ fontSize: 50 }} />,
      sizeIcon: 40,
      onclick: () => handleSeleccionarMetodo(5),
    },
    {
      id: 6,
      nombre: "Efectivo al vendedor",
      icono: <LocalAtmIcon sx={{ fontSize: 50 }} />,
      sizeIcon: 40,
      onclick: () => handleSeleccionarMetodo(6),
    },
  ];
  return (
    <>
      <Grid item sx={{ flex: 0.5 }}>
        <Typography variant="h5" sx={{ p: 5.2 }}>
          ¿Qué medio de pago vas a utilizar?
        </Typography>
      </Grid>
      <Grid item sx={{ flex: 4, p: 4, ml: 5 }}>
        <Grid container spacing={4}>
          {mediosDePago.map(medio => (
            <Grid item xs={4} key={medio.id} sx={{ m: -1 }}>
              <BotonDePago
                key={medio.id}
                nombre={medio.nombre}
                icono={medio.icono}
                onclick={medio.onclick}
                sizeIcon={medio.sizeIcon}
                isSelected={metodoPagoSeleccionado === medio.id}
                isDisabled={
                  metodoPagoSeleccionado !== null &&
                  metodoPagoSeleccionado !== medio.id
                }
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid item sx={{ flex: 0.5 }}></Grid>
    </>
  );
};
